import { parseDate, parseNumber, parseString } from 'utils/parsingHelpers'

export enum CrewRole {
  Supervisor = 'supervisor',
  Operator = 'operator',
  Support = 'support',
}

export interface CrewDetailsJSON {
  crew_id: string
  role: CrewRole
  email: string
  start_date: Date
  end_date: Date
}

export interface PersonnelDetailsJSON {
  data_lead_email?: string
  ehs_coordinator_email?: string
  project_manager_email?: string
  sales_rep_email?: string
  hotel_address?: string
  num_support_tech?: number
  num_operators?: number
  num_supervisors?: number
  day_crew?: CrewDetailsJSON[]
  night_crew?: CrewDetailsJSON[]
}

export const getCrewRole = (value: string) => {
  if (value === CrewRole.Supervisor) return CrewRole.Supervisor
  if (value === CrewRole.Support) return CrewRole.Support
  return CrewRole.Operator
}

const parseCrewDetailsJSON = (value: unknown): CrewDetailsJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  return {
    crew_id: parseString(data.crew_id) ?? '',
    role: getCrewRole(parseString(data.role) ?? ''),
    email: parseString(data.email) ?? '',
    start_date: parseDate(data.start_date) ?? new Date(0),
    end_date: parseDate(data.end_date) ?? new Date(0),
  }
}

export const parsePersonnelDetailsJSON = (
  value: unknown
): PersonnelDetailsJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined
  const data = value as Record<string, unknown>
  return {
    data_lead_email: parseString(data.data_lead_email),
    ehs_coordinator_email: parseString(data.ehs_coordinator_email),
    project_manager_email: parseString(data.project_manager_email),
    sales_rep_email: parseString(data.sales_rep_email),
    hotel_address: parseString(data.hotel_address),
    num_support_tech: parseNumber(data.num_support_tech),
    num_operators: parseNumber(data.num_operators),
    num_supervisors: parseNumber(data.num_supervisors),
    day_crew: Array.isArray(data.day_crew)
      ? data.day_crew
          .map(parseCrewDetailsJSON)
          .filter((x): x is CrewDetailsJSON => x !== undefined)
      : undefined,
    night_crew: Array.isArray(data.night_crew)
      ? data.night_crew
          .map(parseCrewDetailsJSON)
          .filter((x): x is CrewDetailsJSON => x !== undefined)
      : undefined,
  }
}
